<template>
  <div class="userinfo-container">
    <div class="tabs-container">
      <el-button type="success" @click="create" size="small">添加</el-button>
      <el-tabs v-model="filters.type" @tab-click="typeChange">
        <el-tab-pane
          v-for="tab in tabs"
          :key="tab.key"
          :name="tab.key"
          :label="tab.name"
        >
        </el-tab-pane>
      </el-tabs>
    </div>
    <!--列表-->
    <el-table
      stripe
      border
      size="mini"
      :data="datas"
      highlight-current-row
      expand-on-click-node="false"
      style="width: 100%"
    >
      <el-table-column
        prop="Order"
        sortable
        label="显示序号"
        width="120"
      ></el-table-column>
      <el-table-column prop="Image" sortable label="图标" width="100">
        <template slot-scope="scope">
          <viewer v-if="scope.row.Image">
            <img
              v-if="scope.row.Image"
              :src="baseUrl + scope.row.Image"
              :key="scope.row.Image"
              style="height: 40px"
            />
          </viewer>
        </template>
      </el-table-column>
      <el-table-column
        prop="Name"
        sortable
        label="类别名称"
        min-width="200"
      ></el-table-column>
      <el-table-column
        prop="Enabled"
        sortable
        label="是否启用"
        width="150"
      >
      <template slot-scope="scope">
          <el-switch v-model="scope.row.Enabled" @change="doSave(scope.row)"/>
        </template>
    </el-table-column>
      <el-table-column prop="InsertTime" sortable label="创建时间" width="130">
        <template slot-scope="scope">
          {{ format.dateTimeFormat(scope.row.InsertTime) }}
        </template>
      </el-table-column>
      <el-table-column label="操作" width="150">
        <template slot-scope="scope">
          <el-button type="text" size="small" @click="update(scope.row)"
            >修改</el-button
          >
          <el-button type="text" size="small" @click="remove(scope.row)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination-container">
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :page-sizes="pageSizesList"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        :current-page.sync="pageIndex"
      ></el-pagination>
    </div>
    <!--新增界面-->
    <div v-if="formVisible">
      <el-dialog
        v-dragDialog
        :title="formTitle"
        :visible.sync="formVisible"
        width="500px"
        :close-on-click-modal="false"
      >
        <el-form
          :model="dataForm"
          ref="dataForm"
          label-width="130px"
          :rules="dataFormRules"
        >
          <el-form-item label="显示序号：" prop="Order">
            <el-input-number
              size="small"
              v-model="dataForm.Order"
              auto-complete="off"
              placeholder="请输入显示"
            ></el-input-number>
          </el-form-item>
          <el-form-item label="分类名称：" prop="Name">
            <el-input
              size="small"
              v-model="dataForm.Name"
              auto-complete="off"
              placeholder="请输入分类名称"
            ></el-input>
          </el-form-item>
          <el-form-item label="上传图标：" prop="Image">
            <img
              v-if="dataForm.Image"
              :src="baseUrl + dataForm.Image"
              style="height: 80px"
            />
            <el-button
              class="submit-btn"
              type="warning"
              size="mini"
              @click="selectFile"
              >点此上传</el-button
            >
          </el-form-item>
          <el-form-item label="分类归属：" prop="Type">
            <el-radio-group v-model="dataForm.Type" size="small">
              <el-radio-button
                v-for="item in tabs"
                :value="item.value"
                :key="item.value"
                :label="item.value"
                >{{ item.name }}</el-radio-button
              >
            </el-radio-group>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="formVisible = false">取消</el-button>
          <el-button type="primary" @click="handleSubmit">提交</el-button>
        </div>
      </el-dialog>
    </div>
    <fileUploadNoUI
      ref="fileUploadNoUI"
      :compress="false"
      @uploadSuccess="uploadSuccess"
    />
  </div>
</template>
  <script>
import fileUploadNoUI from "@/components/fileUploadNoUI";
import { pcGetCategorys, save, del } from "@/api/business/category";
export default {
  components: { fileUploadNoUI },
  data() {
    return {
      filters: {
        type: "Convenient",
      },
      tabs: [],
      datas: [],
      total: 0,
      pageIndex: 1,
      pageSize: 10,
      pageSizesList: [10, 15, 20, 30, 50],

      formVisible: false,
      formTitle: "添加分类",
      dataForm: {
        Name: "",
        Order: 1,
        Image: "",
        Type: 4,
      },
      dataFormRules: {
        Name: [{ required: true, message: "名称不能为空", trigger: "change" }],
        Order: [{ required: true, message: "序号不能为空", trigger: "change" }],
        Image: [{ required: true, message: "图标不能为空", trigger: "change" }],
        Type: [{ required: true, message: "请选择归属", trigger: "change" }],
      },
    };
  },
  methods: {
    typeChange() {
      this.getList();
    },
    create() {
      this.formVisible = true;
      this.formTitle = "添加分类";
      this.dataForm = {
        Order: 0,
        Name: "",
        Image: "",
        Type: 4,
      };
      this.$nextTick(() => {
        this.$refs["dataForm"].clearValidate();
      });
    },
    update(row) {
      this.dataForm = Object.assign({}, row);
      this.formVisible = true;
      this.formTitle = "修改分类";
      this.$nextTick(() => {
        this.$refs["dataForm"].clearValidate();
      });
    },
    doSave(row){
      save(row)
      .then((response) => {
        if (response) {
          this.msg.successMsg("操作成功");
        }
      });
    },
    handleSubmit: function () {
      this.$refs["dataForm"].validate((valid) => {
        if (valid) {
          let data = Object.assign({}, this.dataForm);
          save(data)
            .then((response) => {
              if (response) {
                this.msg.successMsg("操作成功");
                this.formVisible = false;
                this.getList();
              }
            })
            .catch((ex) => {
              this.msg.errorMsg("出现错误！");
            });
        }
      });
    },
    remove: function (row) {
      this.$confirm("确认删除吗?", "提示", {
        type: "warning",
      }).then(() => {
        let data = { key: row.Key };
        del(data).then((response) => {
          if (response) {
            this.msg.successMsg("操作成功");
            this.getList();
          }
        });
      });
    },
    getList: function () {
      let data = {
        type: this.filters.type,
      };
      pcGetCategorys(data).then((response) => {
        if (response) {
          this.datas = response.Items;
          this.total = response.Total || response.Items.length;
        }
      });
    },
    selectFile() {
      this.$refs.fileUploadNoUI.chooseFile("category");
    },
    uploadSuccess(val) {
      this.dataForm.Image = val.Path;
    },
    handleSizeChange(val) {
      var pageSize = val;
      this.pageIndex = 1;
      this.pageSize = parseInt(pageSize);
      this.$nextTick(() => this.getList());
    },
    handleCurrentChange(val) {
      this.pageIndex = val;
      this.getList();
    },
  },
  mounted() {
    this.tabs = this.$config.categoryType;
    this.getList();
  },
};
</script>
  <style lang='scss' scoped>
.userinfo-container {
  padding: 10px;
}
/deep/.el-dialog {
  margin-top: 10px !important;
}
</style>
  